import TutorDetailCard from './TutorDetailCard';

export default TutorDetailCard;
